package com.macrofocus.nastac.components

import mui.material.Box
import mui.material.Grid
import mui.material.Typography
import mui.system.responsive
import mui.system.sx
import react.FC
import react.Props
import web.cssom.*

// 1. Data Class
data class LegendItem(val year: String, val color: ColorProperty)

// 2. Full Legend Data Array
val legendData: List<LegendItem> = listOf(
    LegendItem("1830s", rgb(0,0,4)), // Black
    LegendItem("1840s", rgb(24,12,59)), // Dark Blue
    LegendItem("1850s", rgb(67,10,104)), // Dark Purple
    LegendItem("1860s", rgb(108,24,110)), // Purple
    LegendItem("1870s", rgb(149,38,103)), // Dark Pink/Maroon
    LegendItem("1880s", rgb(189,56,83)), // Pink/Red
    LegendItem("1890s", rgb(223,83,55)), // Dark Orange
    LegendItem("1900s", rgb(245,122,24)), // Orange
    LegendItem("1910s", rgb(252,159,13)), // Gold
    LegendItem("1920s", rgb(245,219,76))  // Yellow
)
//
// Hypothetical Kotlin JS/React implementation using MUI components

val RShapesLegend = FC<Props> {
    // MUI Box for the main container, potentially to apply padding or border
    Box {
        // Main Title
        Typography {
            // Apply a bold/strong style and appropriate font size
            sx {
                fontWeight = FontWeight.bold }
            +"Year of line construction"
        }

        // Main Grid Container for all 10 items
        Grid {
            // Set 'container' property for Grid
            container = true
            // Add some spacing between items
            spacing = responsive(1)
            // Align all items to start of the line
            asDynamic().justifyContent = "flex-start"

            // Iterate over all 10 items
            legendData.forEach { item ->

                // Grid Item: Represents one full legend entry (swatch + label)
                // Since there are 10 items in 2 rows, each item is 1/5 of the width.
                // MUI Grid system is 12 columns, so 12 / 5 = 2.4. We'll use xs=2
                // for the color swatch and xs=2 for the label, with an extra
                // column for padding, or simply allocate 2 columns for the pair
                // and put 5 pairs in a row. A simpler way is to allocate
                // 2 columns (out of 12) for the swatch+label pair, so 5 pairs fit.

                Grid {
                    this.item = true
//                    xs = 2.4 // 12 columns / 5 items per row = 2.4 columns per item

                    // Stack/Box to hold the Swatch and Label side-by-side
                    Box {
                        sx {
                            display = Display.flex
                            alignItems = AlignItems.center
                        }

                        // 1. Color Swatch (The "Small Box")
                        Box {
                            sx {
                                // Set small box dimensions
                                width = 14.px
                                height = 14.px
                                marginRight = 8.px
                                // Use the color from the data
                                backgroundColor = item.color
                                // Optional: subtle border to define the box
                                border = "1px solid #ccc".unsafeCast<Border>()
                            }
                        }

                        // 2. Decade Label
                        Typography {
                            // Apply a small font size
//                            sx { fontSize = 0.8.rem }
                            +item.year
                        }
                    }
                }
            }
        }
    }
}